// extracted by mini-css-extract-plugin
export var callCard = "_oq-0";
export var callMessageButton = "_oq-1";
export var helpIcon = "_oq-3";
export var helpIconContainer = "_oq-4";
export var verticalDivider = "_oq-2";